export class ServiceHandle {
  handleDetail: string;
  handleTypeId: string;
  serviceId: string;
  id: string;
}


export class HandleType {
  id: string;
  detail: string;
}

